import { Registration } from '@stax-core/types-omni';
import {
  PlaidLinkError,
  PlaidLinkStableEvent,
  PlaidLinkOnExitMetadata,
} from 'react-plaid-link/src/types';
import { onboardingapi } from '../api';

export const plaidErrorEvents = [
  'ERROR',
  'FAIL_OAUTH',
  'IDENTITY_VERIFICATION_FAIL_STEP',
  'IDENTITY_VERIFICATION_FAIL_SESSION',
  'SUBMIT_DOCUMENTS_ERROR',
];

type CallbackErrorType = 'USER_ERROR' | 'PLAID_ERROR';

export function handlePlaidLinkError(
  authToken: string,
  callback?: (
    error: PlaidLinkError | PlaidLinkStableEvent | null,
    type: CallbackErrorType,
  ) => void,
) {
  return async (
    error: PlaidLinkError | PlaidLinkStableEvent | null,
    metadata: PlaidLinkOnExitMetadata,
  ) => {
    let errorType: CallbackErrorType =
      error === 'EXIT' ? 'USER_ERROR' : 'PLAID_ERROR';
    // send error and  metadata to audit
    if (callback) {
      callback(error, errorType);
    }
    if (
      !error ||
      (typeof error === 'string' && !plaidErrorEvents.includes(error)) ||
      !(error as PlaidLinkError).error_type
    ) {
      return;
    }
    if (errorType === 'PLAID_ERROR') {
      await onboardingapi.post(authToken, '/plaid/report', {
        error,
        metadata,
      });
    }
  };
}

export const removeLinkedPlaidAccount = async (authToken, plaidTokenId) => {
  try {
    return (await onboardingapi.delete(
      authToken,
      `/banking/token/remove/${plaidTokenId}`,
    )) as {
      success: boolean;
      message: string;
      registrationChanges?: Partial<Registration>;
    };
  } catch (error) {
    throw Error('There was an issue removing your account');
  }
};
